'use client';

import React from 'react';
import HeaderMenu from './HeaderMenu/HeaderMenu';
import { VStack } from '@skin-seoul/design-system';
import HeaderContent from './HeaderContent/HeaderContent';
import { getLayoutOptions } from '@/utils/layout/layoutFilter';
import { usePathname } from 'next/navigation';
import type { Country } from '@skin-seoul/service';
import FreeShippingBanner from './FreeShippingBanner';
type HeaderClientProps = {
  country: Country;
};
const HeaderClient = ({
  country
}: HeaderClientProps) => {
  const pathname = usePathname();
  const {
    header
  } = getLayoutOptions(pathname);
  if (!header) {
    return null;
  }
  return <VStack backgroundColor="black" gap={0} flexDirection="column" position="relative" width="100%" data-sentry-element="VStack" data-sentry-component="HeaderClient" data-sentry-source-file="Header.client.tsx">
      <FreeShippingBanner data-sentry-element="FreeShippingBanner" data-sentry-source-file="Header.client.tsx" />
      <HeaderContent country={country} data-sentry-element="HeaderContent" data-sentry-source-file="Header.client.tsx" />
      <HeaderMenu data-sentry-element="HeaderMenu" data-sentry-source-file="Header.client.tsx" />
    </VStack>;
};
export default HeaderClient;